import React from 'react';
import { 
  Download, 
  Send, 
  Star, 
  Eye,
  Share2,
  GitCompareArrows,
  PhoneCall
} from 'lucide-react';

export const CompareIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <GitCompareArrows size={16} className={className} />
);

export const DownloadIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Download size={16} className={className} />
);

export const ContactSalesIcon: React.FC<{ className?: string }> = ({ className = ''}) => (
  <PhoneCall size={16} className={className} />
)
export const SendIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Send size={16} className={className} />
);

export const StarIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Star size={16} className={className} fill="currentColor" />
);

export const EyeIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Eye size={16} className={className} />
);

export const ShareIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Share2 size={16} className={className} />
);

